(function () {
    if (document.querySelectorAll(".js-notifications").length > 0) {

        const notifications = {
            store: {},
            init: function () {},
        };

        notifications.init();
    }
})();
